module.exports = __webpack_public_path__ + "static/fonts/Roboto-Light.68b8bb0.eot";